export default {"src":"/_next/static/media/crew-capital-logo.2e3316f9.svg","height":22,"width":264,"blurWidth":0,"blurHeight":0};